import React from 'react';
import './BudgetBike.scss';
import CalculPage from './calculPage/CalculPage';
import ResultPage from './resultPage/ResultPage';
import salarySacrificeTable from '../../mock/salarySacrificeCarrefour'

class BudgetBike extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.state = {
            calculPage: true,
            salary: 0,
            salaryInput: 0,
            unitInput: 'hour',
            hourWorkInput: 36,
            budget: 0,
            monthlyLease: 0
        }

        this.displayRightPage = this.displayRightPage.bind(this);
        this.updateSalaryInput = this.updateSalaryInput.bind(this);
        this.updateUnitInput = this.updateUnitInput.bind(this);
        this.updateHourInput = this.updateHourInput.bind(this);
    }

    calculate() {
        // CALCUL DU SALAIRE
        let salaryToDisplay = 0;

        if(this.state.unitInput === 'hour') {
            // salaire mensuel = Input salaire heure * nb heures semaine * 4.33
            salaryToDisplay = this.state.salaryInput * this.state.hourWorkInput * 4.33;
        } else {
            // salaire mensuel = Input salaire mensuel * [nb heuresemaine / 36]
            salaryToDisplay = this.state.salaryInput * (this.state.hourWorkInput / 36);
        }
        let budgetFind = this.findBudget((salaryToDisplay * 0.92)/12);

        this.setState((prevState: any) => {
            return {
                salary: salaryToDisplay,
                salarySacrifice: (salaryToDisplay * 0.92)/12,
                budget: budgetFind[1],
                monthlyLease: budgetFind[0]
            }
        });
    }

    findBudget(salarySacrifice: number) {
        let budget = 0;
        let monthlyLease = 0;
        let budgetIsFound = false;
        let index = 0;

        while (budgetIsFound === false) {
            if(index === 0 && salarySacrifice < salarySacrificeTable[index][0]) {
                budget = 0;
                monthlyLease = 0;
                budgetIsFound = true;
            }
            if(index !== 0 
                && salarySacrifice >= salarySacrificeTable[index - 1][0]
                && salarySacrifice <= salarySacrificeTable[index][0]) {
                budget = salarySacrificeTable[index - 1][1];
                monthlyLease = salarySacrificeTable[index - 1][0];
                budgetIsFound = true;
            }
            if(salarySacrificeTable.length - 1 === index) {
                budget = salarySacrificeTable[index][1];
                monthlyLease = salarySacrificeTable[index][0];
                budgetIsFound = true;
            }
            index ++;
        }

        return [monthlyLease, budget];
    }

    displayRightPage() {
        this.setState((prevState: any) => {
            return {
                calculPage: prevState.calculPage === true ? false : true
            }
        }, () => this.calculate())
    }

    updateSalaryInput(newSalary: number) {
        this.setState((prevState: any) => {
            return {
                ...prevState,
                salaryInput: newSalary
            }
        }, () => this.calculate())
    }

    updateUnitInput(newUnit: string) {
        this.setState((prevState: any) => {
            return {
                ...prevState,
                unitInput: newUnit
            }
        }, () => this.calculate())
    }

    updateHourInput(newHour: number) {
        this.setState((prevState: any) => {
            return {
                ...prevState,
                hourWorkInput: newHour
            }
        }, () => this.calculate())
    }

    render() {
        return (
            <div className="BudgetBike">
                <div className='leftSide'>
                    {this.state.calculPage ? 
                        <CalculPage
                            salaryInput={this.state.salaryInput}
                            unitInput={this.state.unitInput}
                            hourWorkInput={this.state.hourWorkInput}
                            monthSalary={this.state.salary}
                            displayRightPage={this.displayRightPage}
                            updateSalaryInput={this.updateSalaryInput}
                            updateUnitInput={this.updateUnitInput}
                            updateHourInput={this.updateHourInput}
                        /> 
                    : 
                        <ResultPage 
                            budget={this.state.budget}
                            monthlyLease={this.state.monthlyLease}
                            displayRightPage={this.displayRightPage}
                        />
                    }
                </div>
                <div className='rightSide'></div>
            </div>
        );
    }
}

export default BudgetBike;
